import { ROUTES } from './routes';

export const MAIN_NAV = [
  { label: 'Services', href: ROUTES.services },
  { label: 'Accompagnement', href: '/accompagnement-amazon' },
  { label: 'Creative Studio', href: ROUTES.creative },
  { label: 'Cas clients', href: ROUTES.cases },
  { label: 'Méthode', href: ROUTES.method },
  { label: 'FAQ', href: ROUTES.faq },
  { label: 'Blog', href: '/blog' },
  { label: 'Audit', href: ROUTES.audit }
] as const;